import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=21a0618c"
import script from "./paging.js?vue&type=script&lang=js&external"
export * from "./paging.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports